<template>
<v-container>
  <!-- <v-alert error dismissible @input="onClose" :value="true" class="red--text">
    {{ notification }}
  </v-alert> -->
   <v-alert dismissible @input="onClose" :value="isOpen"         
          text
          color="info"
        >
          <h3 class="text-center">
             {{this.notification.title}} 
           </h3>
          <!-- <div> new update available</div> -->

          <v-divider
            class="my-4 info"
            style="opacity: 0.22"
          ></v-divider>

          <v-row
            align="center"
            no-gutters
          >
            <v-col class="text- center ">
           {{this.notification.Message}} 
            </v-col>
            <!-- <v-spacer></v-spacer> -->
            <!-- <v-col class="shrink">
              <v-btn
                color="info"
                outlined
                @click="alert = !alert"
              >
                Back
              </v-btn>
            </v-col> -->
          </v-row>
        </v-alert> 
</v-container>
</template>

<script>
  export default {
    name: "Notification",
    // props:{
    // notification:{
    //     type: Object,
    //     default:(()=>{})
    //     }
    // },
    computed: {
      notification(){
       return this.$store.getters.thisNotification
      },
      isOpen(){
        if(this.notification.title) 
          return true
        else
         return false       
      },
    },
    methods: {
      onClose () {
        this.$store.dispatch("clearthisNotification")
      }
    }
  }
</script>
